import axios from 'axios';

export const getWaitDelayTypes = async () => {
    const { data } = await axios.get('/app/timerFunnel/getWaitDelayTypes');

    return data;
};

export const getRunOnTypes = async () => {
    const { data } = await axios.get('/app/timerFunnel/getRunOnTypes');

    return data;
};

export const getRunOnDayOfWeekTypes = async () => {
    const { data } = await axios.get('/app/timerFunnel/getRunOnDayOfWeekTypes');

    return data;
};

export const getRunDaysOfWeekInI18nOptions = async () => {
    const { data } = await axios.get('/app/timerFunnel/getRunDaysOfWeekInI18n');

    return data;
};

export const getRunOnMonthTypes = async () => {
    const { data } = await axios.get('/app/timerFunnel/getRunOnMonthTypes');

    return data;
};

export const getMonthsInI18n = async () => {
    const { data } = await axios.get('/app/timerFunnel/getMonthsInI18n');

    return data;
};

export const getDaysOfMonth = async () => {
    const { data } = await axios.get('/app/timerFunnel/getDaysOfMonth');

    return data;
};

export const getWeeksInLocale = async () => {
    const { data } = await axios.get('/app/timerFunnel/getWeeksInLocale');

    return data;
};

export const getMonthsInLocale = async () => {
    const { data } = await axios.get('/app/timerFunnel/getMonthsInLocale');

    return data;
};

export const loadDateAndDateTimeFieldMap = async () => {
    const { data } = await axios.get('/app/fieldValueFunnel/dateAndDateTimeFieldMap');
    const rawFields = Object.entries(data);
    const formattedFields = [];

    rawFields.forEach(([key, fieldName]) => {
        formattedFields.push({ value: key, label: fieldName });
    });

    return formattedFields;
};

export const loadDateTimeFieldMap = async () => {
    const { data } = await axios.get('/app/fieldValueFunnel/dateTimeFieldMap');
    const rawFields = Object.entries(data);
    const formattedFields = [];

    rawFields.forEach(([key, fieldName]) => {
        formattedFields.push({ value: key, label: fieldName });
    });

    return formattedFields;
};
